import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-book-page',
  templateUrl: './book-page.component.html'
})
export class BookPageComponent implements OnInit {
  @HostBinding() class = 'book-page amadeus-direct-style';
  isHeaderAllowed$: Observable<boolean>;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit() {
    this.isHeaderAllowed$ = this.route.url.pipe(
      switchMap(() => this.route.firstChild.url),
      map(segments => segments.length && segments[0].path === 'order')
    );
  }
}
